module.exports = __webpack_public_path__ + "core-img/ajax-loader.a0ec57a6c6fdd43271aabba2c487b871.gif";


//////////////////
// WEBPACK FOOTER
// ./src/main/ui/core/gfx/ajax-loader.gif
// module id = 36
// module chunks = 0